import {useEffect, useRef} from 'react'
import {Routes, Route, Navigate} from 'react-router-dom'
import {useAuth} from './core/Auth'

export function Logout() {
    
    const {logout, currentUser} = useAuth()
    
    const wasSetsco = useRef(currentUser ? currentUser.isSetsco : false);
    
    useEffect(() => {        
        logout()
        // window.location.reload()
        // eslint-disable-next-line
    }, [])

    
    return (
    <Routes>
        <Route
            path=""
            element={<Navigate to={ wasSetsco.current ? '/setsco/auth/login' :  '/auth/login'} />}
        />        
    </Routes>
    )
}
